import React from 'react';
import './ServiceParallaxSection.css';

const sections = [
  {
    title: 'Expert Architectural Lighting Design',
    text: 'You design your residence - we’ll transform it into a home with the perfect lighting.',
    image: require('../Images/ServiceImage1.jpg'),
  },
  {
    title: 'One-stop Light Studio',
    text: 'No more running around for parts - we provide everything under one roof.',
    image: require('../Images/Light3.jpg'),
  },
  {
    title: 'Outstanding Customer Support',
    text: 'Our technically sound team is at your service - even beyond business hours.',
    image: require('../Images/Services4.png'),
  },
  {
    title: 'Incredible Customization',
    text: 'You envision the experience - you\'ll see us bring it to life',
    image: require('../Images/Light4.jpg'),
  },
  {
    title: 'Competitive Long-term Warranty',
    text: 'We stand by our products - and our promises - for the long run.',
    image: require('../Images/ServiceImage2.jpg'),
  },
  {
    title: 'Best Value for Price',
    text: 'We deliver exactly what we promise - often more, never less.',
    image: require('../Images/Services2.jpeg'),
  },
  {
    title: 'Shortest Lead Time',
    text: 'Special requests? We handle them quickly and with care.',
    image: require('../Images/Light4.jpg'),
  },
  {
    title: 'Wireless automation',
    text: 'Experience the future of lighting—control everything wirelessly, effortlessly.',
    image: require('../Images/Light3.jpg'),
  },
  {
    title: '3D Lighting Product Design',
    text: 'Can’t find it in our catalog? We’ll design it from scratch - just for you.',
    image: require('../Images/Services3.jpeg'), 
  },
  {
    title: 'AR Lighting Design',
    text: 'Visualize your space in augmented reality with true-to-life lighting effects.',
    image: require('../Images/Light5.jpg'),
  }
];

const ServiceParallaxSection = () => {
  return (
    <div className="info-parallax-alt-root">
      {sections.map((section, idx) => (
        <section className={`info-parallax-alt-section${idx % 2 === 1 ? ' reverse' : ''}`} key={idx}>
          <div
            className="info-parallax-alt-bg"
            style={{ backgroundImage: `url(${section.image})` }}
            aria-hidden="true"
          />
          <div className="info-parallax-alt-details">
            <h2>{section.title}</h2>
            <p>{section.text}</p>
          </div>
        </section>
      ))}
    </div>
  );
};

export default ServiceParallaxSection;